module.exports = __webpack_public_path__ + "img/logo.81f192b0.png";